angular.module('tf.directives')


    .service('BreadCrumbsService', ['$state',function($state){

        var rootState = {name : 'app.farmers'};
        var bc = [rootState];


        this.set = function(newBC){
            if(newBC) {
                bc = [rootState].concat(newBC);
            } else {
                this.clear();
            }

        };

        this.get = function () {
            return bc;
        };
        this.last = function () {
            if(bc.length > 1){
                return bc[bc.length - ($state.current.name === 'app.project'? 1 : 2)];
            }
        };
        this.clear = function () {
            bc = [rootState];
        };

        this.isEmpty = function(){
            return bc.length < 1;
        };

        return this;
    }])

    .directive("tfBreadcrumbs",['BreadCrumbsService', function(BreadCrumbsService){
        return {
            restrict: "E",
            replace:true,
            scope: {
                data: "="
            },
            controller: 'BreadcrumbsController',
            templateUrl: "js/components/breadcrumbs/breadcrumbs.html",
            link: function(scope){
               // $scope.data = scope.data;
                //BreadCrumbsService.set(scope.data);
            }
        };

    }])

    .controller("BreadcrumbsController",['$scope','$rootScope', '$state', 'ShareService','ProjectService','$stateParams', 'Session',function($scope, $rootScope, $state, ShareService, ProjectService, $stateParams, Session){

        $scope.role = Session.role;

        $scope.share = function(){
            if($rootScope.currentLocation) {
                ShareService.open($rootScope.currentLocation);
            }
        };
        $scope.inProject = function(){
            return $state.current.name === 'app.project';
        };
        $scope.getProjectName = function () {
            return ProjectService.project.name;
        };

        $scope.isDemo = function () {
            return !!$stateParams.demo;
        };

        $scope.project = ProjectService.project;
        $scope.safeNameRegex = ProjectService.safeNameRegex;
    }]);